import type { UseFetchOptions } from 'nuxt/app'
import type { StrapiEventListPage } from '~/composables/types/strapiEventListPage'
import type { StrapiApiDefaultResponse } from '~/composables/types/strapi-api'
import type { StrapiMagazineArticle } from '~/composables/types/strapi/strapi-magazine'

export function useStrapiArticlesCategory({
  slug,
  query,
  options = {},
  locale,
}: {
  slug?: string
  query?: Record<string, string>
  options?: UseFetchOptions<
    StrapiApiDefaultResponse<StrapiEventListPage[]>,
    StrapiEventListPage[]
  >
  locale?: string
} = {}) {
  const config = useRuntimeConfig()
  const { strapiApiBaseURL, strapiApiKey } = config.public
  const localeDefault = useI18n().locale
  const articlesCategoryUrl = getStrapiArticlesCategoryUrl(
    strapiApiBaseURL,
    slug ?? '',
    locale ?? localeDefault.value
  )

  const defaults: UseFetchOptions<
    StrapiApiDefaultResponse<StrapiMagazineArticle[]>,
    StrapiMagazineArticle[]
  > = {
    baseURL: strapiApiBaseURL,
    key: articlesCategoryUrl.toString(),

    headers: {
      Authorization: `Bearer ${strapiApiKey}`,
    },
    transform: (data) => {
      return data.data
    },
  }

  const params = { ...options, ...defaults }

  return useLazyFetch(articlesCategoryUrl.toString(), params)
}
